import { get, put } from '../client';

export const systemConfigApi = {
  list: () => get('/system-config'),
  getByKey: (key) => get(`/system-config/${key}`),
  update: (key, value) => put(`/system-config/${key}`, { value: String(value) }),
};
